/**
 * lang 和 locale差别
 * @link http://sailing.intra.didiglobal.com/#/knowledgeDetail?360287970189696528
 * 开国信息
 * @link http://sailing.intra.didiglobal.com/#/knowledgeDetail?72057594042023454
 */

/**
 * 语言信息集
 */
export enum LANG_CODE {
  /**
   * 英语
   */
  EN_US = 'en-US',
  /**
   * 墨西哥语言
   */
  ES_MX = 'es-MX',
}

/**
 * 区域信息集
 */
export enum LOCALE_CODE {
  /**
   * 墨西哥用户
   */
  ES_MX = 'es_MX',
}
